var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.5V10.5M18.5 10.5V13.5M18.5 10.5H21.5M18.5 10.5H15.5M13.25 6.375C13.25 8.23896 11.739 9.75 9.875 9.75C8.01104 9.75 6.5 8.23896 6.5 6.375C6.5 4.51104 8.01104 3 9.875 3C11.739 3 13.25 4.51104 13.25 6.375ZM3.50092 19.2343C3.50031 19.198 3.5 19.1615 3.5 19.125C3.5 15.6042 6.35418 12.75 9.875 12.75C13.3958 12.75 16.25 15.6042 16.25 19.125V19.1276C16.25 19.1632 16.2497 19.1988 16.2491 19.2343C14.3874 20.3552 12.2065 21 9.875 21C7.54353 21 5.36264 20.3552 3.50092 19.2343Z",
    stroke: "#278272",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user_plus.ab95dbabed25ed0c1a95217679ade6af.svg";
export { ForwardRef as ReactComponent };